module.exports = "/fonts/hashed/NotoSansSC-SemiBold.19bf6893.ttf.gz.bin";